module.exports = __webpack_public_path__ + "static/img/mica-1.3abdfaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/mica-1.jpg
// module id = psu9
// module chunks = 1